<label>{{ formattedLabel }}</label>